import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "/app/src/Web/InternetBranch/node_modules/core-js/modules/es6.array.iterator.js";
import "/app/src/Web/InternetBranch/node_modules/core-js/modules/es6.promise.js";
import "/app/src/Web/InternetBranch/node_modules/core-js/modules/es6.object.assign.js";
import "/app/src/Web/InternetBranch/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import ElementUI from 'element-ui';
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import i18n from "./lang"; // Internationalization
import * as filters from "./filters"; // global filters
import * as VueGoogleMaps from 'vue2-google-maps'; // google-map
import "./permission"; // permission control
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/tr-TR';
import fullscreen from 'vue-fullscreen';
import VueAnalytics from 'vue-analytics';
import OtpInput from '@bachdgvn/vue-otp-input';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueAnalytics, {
  id: 'UA-169256848-1',
  router: router
});
Vue.use(fullscreen);
Vue.use(ElementUI, {
  locale: locale
});
Vue.use(ElementUI);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDD88wwCTlUfLmxuy7H_lGXxT-R8fj1Nb4',
    libraries: 'places'
  }
});
Vue.use(VueClipboard);
Vue.directive('uppercase', {
  inserted: function inserted(el, _, vnode) {
    el.addEventListener('keyup', function (e) {
      e.target.value = e.target.value.toLocaleUpperCase('tr-TR');
      vnode.componentInstance.$emit('input', e.target.value.toLocaleUpperCase('tr-TR'));
    });
  }
});
Vue.component('info-window', VueGoogleMaps.InfoWindow);
Vue.component('v-otp-input', OtpInput);
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');